var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartMixedPorcentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0254 3.02539L2.90039 21.1504L1.9375 22.1133L0.0117188 20.1875L0.974609 19.2246L19.0996 1.09961L20.0625 0.193359L21.9883 2.0625L21.0254 3.02539ZM1.03125 1.15625H6.46875V6.59375H1.03125V1.15625ZM15.5312 15.6562H20.9688V21.0938H15.5312V15.6562Z",
    fill: "#0962AD",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartMixedPorcentage);
export default __webpack_public_path__ + "static/media/chart-mixed-porcentage.6dbc8917112d450326f492927e51619f.svg";
export { ForwardRef as ReactComponent };